
export const NEW_CONTROLE_CONTA_CAIXA = 'NEW_CONTROLE_CONTA_CAIXA'
export const NEW_CONTROLE_CONTA_CAIXA_SUCCESS = 'NEW_CONTROLE_CONTA_CAIXA_SUCCESS'

export const NEW_FILTER_CONTROLE_CONTA_CAIXA = 'NEW_FILTER_CONTROLE_CONTA_CAIXA'
export const NEW_FILTER_CONTROLE_CONTA_CAIXA_PEDING = 'NEW_FILTER_CONTROLE_CONTA_CAIXA_PEDING'
export const NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS = 'NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS'
export const NEW_FILTER_CONTROLE_CONTA_CAIXA_FAILURE = 'NEW_FILTER_CONTROLE_CONTA_CAIXA_FAILURE'
export const NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS_PDF = 'NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS_PDF'

export const NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA = 'NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA'
export const NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_PENDING = 'NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_FAILURE'

export const GET_TOTAIS_CONTROLE_CONTA_CAIXA_PENDING = 'GET_TOTAIS_CONTROLE_CONTA_CAIXA_PENDING'
export const GET_TOTAIS_CONTROLE_CONTA_CAIXA_SUCCESS = 'GET_TOTAIS_CONTROLE_CONTA_CAIXA_SUCCESS'
export const GET_TOTAIS_CONTROLE_CONTA_CAIXA_FAILURE = 'GET_TOTAIS_CONTROLE_CONTA_CAIXA_FAILURE'

export const CREATE_CONTROLE_CONTA_CAIXA = 'CREATE_CONTROLE_CONTA_CAIXA'
export const CREATE_CONTROLE_CONTA_CAIXA_PENDING = 'CREATE_CONTROLE_CONTA_CAIXA_PENDING'
export const CREATE_CONTROLE_CONTA_CAIXA_SUCCESS = 'CREATE_CONTROLE_CONTA_CAIXA_SUCCESS'
export const CREATE_CONTROLE_CONTA_CAIXA_FAILURE = 'CREATE_CONTROLE_CONTA_CAIXA_FAILURE'

export const LIST_CONTROLE_CONTA_CAIXA = 'LIST_CONTROLE_CONTA_CAIXA'
export const LIST_CONTROLE_CONTA_CAIXA_PENDING = 'LIST_CONTROLE_CONTA_CAIXA_PENDING'
export const LIST_CONTROLE_CONTA_CAIXA_SUCCESS = 'LIST_CONTROLE_CONTA_CAIXA_SUCCESS'
export const LIST_CONTROLE_CONTA_CAIXA_FAILURE = 'LIST_CONTROLE_CONTA_CAIXA_FAILURE'

export const FIND_CONTROLE_CONTA_CAIXA = 'FIND_CONTROLE_CONTA_CAIXA'
export const FIND_CONTROLE_CONTA_CAIXA_PENDING = 'FIND_CONTROLE_CONTA_CAIXA_PENDING'
export const FIND_CONTROLE_CONTA_CAIXA_SUCCESS = 'FIND_CONTROLE_CONTA_CAIXA_SUCCESS'
export const FIND_CONTROLE_CONTA_CAIXA_FAILURE = 'FIND_CONTROLE_CONTA_CAIXA_FAILURE'

export const DELETE_CONTROLE_CONTA_CAIXA = 'DELETE_CONTROLE_CONTA_CAIXA'
export const DELETE_CONTROLE_CONTA_CAIXA_PENDING = 'DELETE_CONTROLE_CONTA_CAIXA_PENDING'
export const DELETE_CONTROLE_CONTA_CAIXA_SUCCESS = 'DELETE_CONTROLE_CONTA_CAIXA_SUCCESS'
export const DELETE_CONTROLE_CONTA_CAIXA_FAILURE = 'DELETE_CONTROLE_CONTA_CAIXA_FAILURE'
